import { render } from "./LinkVariant.vue?vue&type=template&id=642700ad"
import script from "./LinkVariant.vue?vue&type=script&lang=js"
export * from "./LinkVariant.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__